// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />

export class RetailerTypeAhead {

	private _url: string;
	private _emptyGuid: string = "00000000-0000-0000-0000-000000000000";

	private _otherRetailerOptions = [
		{ "CompanyId": "10000", "CompanyName": "Other Online Store" },
		{ "CompanyId": "20000", "CompanyName": "Other In Store Retailer" }
	];

	constructor(url) {
		this._url = url;
	}

	Setup() {

		var retailerDatasource = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.obj.whitespace('CompanyName'),
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			remote: {
				url: this._url + '/RetailerTypeahead/?query=%QUERY&ctype=R',
				wildcard: '%QUERY'
			}
		});

		var onlineRetailerDatasource = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.obj.whitespace('CompanyName'),
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			remote: {
				url: this._url + '/RetailerTypeahead/?query=%QUERY&ctype=O',
				wildcard: '%QUERY'
			}
		});

		var map = {};
		var objects = [];

		$('#ApplicationInformation_RetailerTypeaheadName').typeahead({
			highlight: true,
			minLength: 0
		}, {
			limit: 20,
			name: 'retailers-stores',
			display: 'CompanyName',
			source: retailerDatasource,
			templates: {

				notFound: [
					'<h4 class="retailer-source-name">In Store Retailers</h4>',
					'<div class="retailer-empty-message">No Results Found</div>'
				].join('\n'),
				header: '<h4 class="retailer-source-name">In Store Retailers</h4>'
			}

		}, {
			limit: 20,
			name: 'online-retailers-stores',
			display: 'CompanyName',
			source: onlineRetailerDatasource,

			templates: {
				notFound: [
					'<h4 class="retailer-source-name">Online Retailers</h4>',
					'<div class="retailer-empty-message">No Results Found</div>'
				].join('\n'),
				header: '<h4 class="retailer-source-name">Online Retailers</h4>'
			}

		}, {
			name: 'other-retailers-stores',
			display: 'CompanyName',

			source: (query, syncResults, asyncResults) => {
				objects = [];
				$.each(this._otherRetailerOptions, (i, object) => {
					map[object.CompanyName] = object;
					//objects.push(object.CompanyName);
					objects.push(object);
				});
				syncResults(objects);
			},
			templates: {
				header: '<h4 class="retailer-source-name">Other Retailers</h4>'
			}
		}).on("typeahead:select", (evt, item) => {
			if (item.CompanyId != this._emptyGuid) {
				$("#ApplicationInformation_RetailerTypeaheadId").val(item.CompanyId);
				$("#ApplicationInformation_RetailerTypeaheadIdType").val("C");
			} else if (item.StoreId != this._emptyGuid) {
				$("#ApplicationInformation_RetailerTypeaheadId").val(item.StoreId);
				$("#ApplicationInformation_RetailerTypeaheadIdType").val("S");
			}
			RetailerTypeAhead.ClearOtherRetailerFields();
			RetailerTypeAhead.ShowHideRetailerOtherFields();
			console.log("select-" + $("#ApplicationInformation_RetailerTypeaheadId").val());
		}).on("typeahead:autocomplete", (evt, item) => {
			if (item.CompanyId != this._emptyGuid) {
				$("#ApplicationInformation_RetailerTypeaheadId").val(item.CompanyId);
				$("#ApplicationInformation_RetailerTypeaheadIdType").val("C");
			} else if (item.StoreId != this._emptyGuid) {
				$("#ApplicationInformation_RetailerTypeaheadId").val(item.StoreId);
				$("#ApplicationInformation_RetailerTypeaheadIdType").val("S");
			}
			RetailerTypeAhead.ClearOtherRetailerFields();
			RetailerTypeAhead.ShowHideRetailerOtherFields();
			console.log("autocomplete - " + $("#ApplicationInformation_RetailerTypeaheadId").val());
		}).blur(() => {
			console.log("blur: " + $("#ApplicationInformation_RetailerTypeaheadId").val());

			var rid = $("#ApplicationInformation_RetailerTypeaheadId").val();
			if (rid == "" || rid == null) {
				this.SetRetailerError("ApplicationInformation.RetailerTypeaheadName", "Please select a retailer from the list.");
				$('#ApplicationInformation_RetailerTypeaheadName').val("");
			} else {
				this.SetRetailerError("ApplicationInformation.RetailerTypeaheadName", "");
			}

		}).keyup((e) => {
			//Ignore tab
			if (e.keyCode != 9) {
				$("#ApplicationInformation_RetailerTypeaheadId").val("");
			}
		});

	}

	public static ShowHideRetailerOtherFields() {
		var companyId = $("#ApplicationInformation_RetailerTypeaheadId").val();
		if (companyId == "10000") {
			$("#retailerOtherOnline").removeClass("d-none").show();
			$("#retailerOtherInstore").hide();
		} else if (companyId == "20000") {
			$("#retailerOtherOnline").hide();
			$("#retailerOtherInstore").removeClass("d-none").show();
		} else {
			$("#retailerOtherOnline").hide();
			$("#retailerOtherInstore").hide();
		}
	}

	private static ClearOtherRetailerFields() {
		var otherOnlineDiv = $("#retailerOtherOnline");
		otherOnlineDiv.find("input:text").val("");
		var otherInstoreDiv = $("#retailerOtherInstore");
		otherInstoreDiv.find("input:text").val("");
	}

	SetRetailerError(id, message) {
		var span = $("span[data-valmsg-for=\"" + id + "\"]");
		if (span && span.length > 0) {
			$(span).html(message);
			if (message && message != "") {
				$(span).removeClass("field-validation-valid");
				$(span).addClass("field-validation-no-valid");
			} else {
				$(span).removeClass("field-validation-no-valid");
				$(span).addClass("field-validation-valid");
			}
		}
	}


}